var AuthorizedRoute = require('../mixins/authorized-route')
var Scope = require('../utils/scope')

module.exports = Em.Route.extend(AuthorizedRoute, {
    queryParams: {
        fromRenewing: {
            replace: true
        },
        reloadAccount: {
            replace: true
        }
    },

    scopes: [Scope.BankReconciliationRead],

    bankConnections: Em.inject.service(),

    bankAccounts: Ember.inject.service(),

    beforeModel: function(transition) {
        this._super.apply(this, arguments)

        var queryParams = transition.queryParams || {}
        var self = this

        if (queryParams.reloadAccount === 'true') {
            var accountId = transition.params.bank_account.account_id
            if (accountId) {
                var api = this.container.lookup('api:billy')
                var organizationId = this.modelFor('organization').get('id')

                return api.get('/accounts?organizationId=' + organizationId)
                    .then(function(response) {
                        if (response.accounts) {
                            BD.store.loadAll(Billy.Account, response.accounts)
                        }

                        self._reloadedAccount = Billy.Account.find(accountId)
                        return self._reloadedAccount
                    })
            }
        }
    },

    model: function() {
        if (this._reloadedAccount) {
            var account = this._reloadedAccount
            this._reloadedAccount = null
            return account
        }
        return this.modelFor('bank_account')
    },

    setupController: function(controller, model) {
        controller.set('model', model)

        var queryParams = this.paramsFor(this.routeName)
        var bankConnections = this.get('bankConnections')
        var bankAccounts = this.get('bankAccounts')
        var shouldReload = !bankConnections.get('isLoaded') && bankConnections.get('isBankSyncReadAuthorized')
        var bankConnectionEstablished = queryParams.bankConnectionEstablished === 'true'

        bankAccounts.ensureLoaded()

        if (shouldReload || bankConnectionEstablished) {
            bankConnections.load().then(function() {
                var startedPolling = controller.checkAndStartPolling(bankConnectionEstablished)
                if (!startedPolling) {
                    controller.loadBankMatches()
                }
            })
        } else {
            bankConnections.set('isLoaded', true)
            controller.loadBankMatches()
        }

        this.controllerFor('bank-sync-possible-subjects').load()
    },

    deactivate: function() {
        this._super()
        var bankSyncMatchesController = this.controllerFor('bank-sync-matches')

        if (bankSyncMatchesController) {
            bankSyncMatchesController.set('_isPollingActive', false)
            bankSyncMatchesController.stopPolling()
        }

        var bankConnections = this.get('bankConnections')
        if (bankConnections) {
            bankConnections.set('isLoaded', false)
        }
    }
})
